import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityEventInput = () => {
  const { eventId = '' } = useParams();
  const decodedId = eventId ? atob(eventId) : eventId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityEvent';

  useEffect(() => {
    if (eventId) { setIsEditing(true); fetchDetails(); }
  }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityEvent'] + id + '/', { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        ...d,
        opportunity: d.opportunity?.id ?? d.opportunity,
        organizer: d.organizer?.id ?? d.organizer,
      });
    } catch (error) { console.error('Error fetching Opportunity Event details:', error); }
  };

  const fields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    { name: 'title', label: 'Event Title', type: 'text' },
    { name: 'event', label: 'Event Name', type: 'text' },
    { name: 'event_date', label: 'Event Date & Time', type: 'datetime-local', dateConstraint: 'future' },
    {
      name: 'event_type', label: 'Event Type', type: 'select',
      options: [
        { value: 'demo', label: 'Product Demo' },
        { value: 'presentation', label: 'Presentation' },
        { value: 'workshop', label: 'Workshop' },
        { value: 'networking', label: 'Networking' },
        { value: 'conference', label: 'Conference' },
        { value: 'webinar', label: 'Webinar' },
        { value: 'site_visit', label: 'Site Visit' },
        { value: 'other', label: 'Other' },
      ],
    },
    { name: 'start_date', label: 'Start Date & Time', type: 'datetime-local', dateConstraint: 'future' },
    { name: 'end_date', label: 'End Date & Time', type: 'datetime-local', dateConstraint: 'future' },
    { name: 'location', label: 'Location / Venue', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
      name: 'organizer', label: 'Organizer', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    {
      name: 'event_status', label: 'Status', type: 'select',
      options: [
        { value: 'scheduled', label: 'Scheduled' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'postponed', label: 'Postponed' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Event' : 'Create Opportunity Event'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityEventInput;
